sn-hero-header-type-4 {
  .sn-hero-header-type-4 {
    position: relative;
    padding-top: px-to-rem(40px);
    padding-bottom: px-to-rem(80px);

    @include desktop {
      padding-top: px-to-rem(104px);
      padding-bottom: px-to-rem(104px);
    }

    @include above(960px) {
      padding-top: px-to-rem(100px);
      padding-bottom: px-to-rem(100px);
    }

    @include above(1200px) {
      padding-top: px-to-rem(122px);
      padding-bottom: px-to-rem(100px);
    }
  }

  .sn-hero-header-type-4__container {
    max-width: $sn-container-max-width;
    margin: 0 auto;
    padding: 0 px-to-rem(16px);

    @include desktop {
      padding: 0 px-to-rem(24px);
    }
  }

  .sn-hero-header-type-4__row {
    @include above(960px) {
      display: flex;
      align-items: flex-start;
    }
  }

  // ── Left column (details) ────────────────────────────────────────
  .sn-hero-header-type-4__column--details {
    text-align: center;

    @include above(960px) {
      flex-shrink: 0;
      width: px-to-rem(451px);
      text-align: left;
      margin-right: px-to-rem(49px);
    }

    @include above(1200px) {
      width: px-to-rem(533px);
      margin-right: px-to-rem(111px);
    }

    me-heading {
      font-size: px-to-rem(28px);
      line-height: px-to-rem(40px);
      margin-top: 0;
      margin-bottom: px-to-rem(12px);

      @include desktop {
        font-size: px-to-rem(36px);
        line-height: px-to-rem(48px);
        margin-bottom: px-to-rem(16px);
      }

      @include above(960px) {
        text-align: left;
        font-size: px-to-rem(40px);
      }

      @include above(1200px) {
        font-size: px-to-rem(52px);
        line-height: px-to-rem(64px);
        margin-bottom: px-to-rem(20px);
      }
    }

    me-text {
      display: block;
      font-size: px-to-rem(14px);
      line-height: px-to-rem(20px);
      margin-bottom: px-to-rem(24px);

      @include desktop {
        font-size: px-to-rem(16px);
        line-height: px-to-rem(24px);
        margin-bottom: px-to-rem(22px);
      }

      @include above(1200px) {
        font-size: px-to-rem(20px);
        line-height: px-to-rem(28px);
        margin-bottom: px-to-rem(50px);
      }
    }
  }

  // ── Right column (form) ──────────────────────────────────────────
  .sn-hero-header-type-4__column--form {
    display: flex;
    justify-content: center;

    @include above(960px) {
      flex: 1;
      display: block;
    }
  }

  // ── Benefits checklist ───────────────────────────────────────────
  .sn-hero-header-type-4__benefits {
    margin-bottom: px-to-rem(22px);
    text-align: left;

    @include desktop {
      margin-bottom: px-to-rem(106px);
    }

    @include above(960px) {
      margin-bottom: px-to-rem(4px);
    }

    .me-list {
      gap: px-to-rem(10px) px-to-rem(13px);

      @include above(960px) {
        gap: px-to-rem(12px) px-to-rem(20px);
      }
    }

    .me-list__item {
      position: relative;
      font-weight: 700;
      font-size: px-to-rem(14px);
      line-height: px-to-rem(24px);
      padding-left: px-to-rem(29px);

      @include above(960px) {
        font-size: px-to-rem(20px);
        padding-left: px-to-rem(40px);
        line-height: px-to-rem(28px);
      }

      .me-list__icon {
        display: none;
      }

      &::before {
        position: absolute;
        content: '';
        left: 0;

        // Green circle checkmark
        background-image: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjUiIHZpZXdCb3g9IjAgMCAyNCAyNSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMiAyNC41QzUuMzcyIDI0LjUgMCAxOS4xMjggMCAxMi41QzAgNS44NzIgNS4zNzIgMC41IDEyIDAuNUMxOC42MjggMC41IDI0IDUuODcyIDI0IDEyLjVDMjQgMTkuMTI4IDE4LjYyOCAyNC41IDEyIDI0LjVaIiBmaWxsPSIjMDBDNkIxIi8+CjxwYXRoIGQ9Ik0xNy4zMzMyIDkuODMzMzdMMTAuNjY2NSAxNi41TDYuNjY2NSAxMi41IiBzdHJva2U9IndoaXRlIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=');
        background-size: contain;
        background-repeat: no-repeat;
        width: px-to-rem(18px);
        height: px-to-rem(18px);
        top: px-to-rem(3px);

        @include above(960px) {
          width: px-to-rem(24px);
          height: px-to-rem(25px);
          top: px-to-rem(2px);
        }
      }
    }
  }

  // ── Form wrapper card ─────────────────────────────────────────────
  .sn-hero-header-type-4__form-wrapper {
    display: block;
    width: 100%;
    position: relative;
    background: var(--background-color-primary);
    box-shadow: 0 5px 25px 0 rgb(0 0 0 / 10%);
    padding: px-to-rem(36px) px-to-rem(16px) px-to-rem(32px);
    margin: 0 px-to-rem(-16px) px-to-rem(34px);

    @include desktop {
      border-radius: var(--radius-size-md);
      margin: 0 auto px-to-rem(56px);
      padding: px-to-rem(40px) px-to-rem(36px);
    }

    @include above(960px) {
      padding: px-to-rem(40px);
      box-shadow: 0 15px 25px 0 rgb(0 0 0 / 10%);
      margin: 0;
    }

    @include above(1200px) {
      box-shadow: 0 20px 80px 0 rgb(0 0 0 / 10%);
      top: px-to-rem(-22px);
      padding: px-to-rem(44px) px-to-rem(52px);
    }

    // Rotated #D5E6FF block behind the white card.
    // z-index:-1 without isolation pushes it behind form-wrapper in the parent stacking context;
    // background:#fff on the card makes the white surface paint over the blue where they overlap,
    // leaving only the rotated corners/edges of the blue block visible around the card.
    &::after {
      @include desktop {
        position: absolute;
        content: '';
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        background: var(--sn-hero-header-type-4-decoration-color, #d5e6ff);
        border-radius: var(--radius-size-lg);
        transform: rotate(7deg);
        z-index: -1;
      }
    }

    // Decorative SVG ornament (hidden on mobile, shown from tablet+)
    &::before {
      position: absolute;
      content: '';
      right: px-to-rem(-53px);
      display: none;

      // Squiggle SVG ornament from source form-wrapper::before
      background: url('data:image/svg+xml;base64,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')
        no-repeat;
      background-size: contain;

      @include desktop {
        display: block;
        width: px-to-rem(134px);
        height: px-to-rem(179px);
        top: px-to-rem(-37px);
        right: px-to-rem(-70px);
      }

      @include above(960px) {
        width: px-to-rem(99px);
        height: px-to-rem(145px);
        right: px-to-rem(-40px);
      }

      @include above(1200px) {
        width: px-to-rem(161px);
        height: px-to-rem(215px);
        right: px-to-rem(-90px);
        top: px-to-rem(-62px);
      }
    }

    // ── Optional form heading (e.g. "Talk to Sales") ────────────────
    .sn-hero-header-type-4__form-heading {
      &:empty {
        display: none;
      }

      me-heading {
        display: block;
        text-align: center;
        font-size: px-to-rem(28px);
        line-height: px-to-rem(36px);
        font-weight: 700;
        margin: 0 0 px-to-rem(16px);

        @include desktop {
          font-size: px-to-rem(32px);
          line-height: px-to-rem(40px);
        }
      }
    }

    // ── Optional "mandatory fields" note ────────────────────────────
    .sn-hero-header-type-4__form-notice {
      &:empty {
        display: none;
      }

      font-size: px-to-rem(12px);
      line-height: px-to-rem(16px);
      color: var(--color-text-secondary, #666);
      margin-bottom: px-to-rem(16px);

      me-text {
        display: block;
      }
    }

    me-input,
    me-select {
      display: block;
      margin-bottom: px-to-rem(17px);

      @include desktop {
        margin-bottom: px-to-rem(20px);
      }
    }

    .sn-hero-header-type-4__form-row {
      display: flex;
      gap: px-to-rem(12px);
      margin-bottom: px-to-rem(17px);

      @include desktop {
        margin-bottom: px-to-rem(20px);
      }

      me-input,
      me-select {
        flex: 1 1 0;
        min-width: 0;
        margin-bottom: 0;
      }
    }

    me-button {
      display: block;
      width: 100%;
      margin-bottom: px-to-rem(16px);

      .me-button {
        width: 100%;
      }
    }

    .sn-hero-header-type-4__agreement-note {
      display: block;
      font-size: px-to-rem(12px);
      line-height: px-to-rem(16px);
      color: var(--color-text-secondary, #666);
      margin-bottom: 0;

      a {
        color: var(--text-color-brand-primary);
        text-decoration: underline;

        &:hover {
          color: #008bf8;
        }
      }
    }
  }
}
